var users = {}
users.db = null
const logs = require("@/classes/logs/logs.js").Logs;
users.init = async function (parent) {
    this.db = parent.fb;
    this.parent = parent
    this.email = await parent.adminUser.getAccount();

    //logs.print("type:", parent.type)
    //this.ref = this.db.playersCollection
    //this.usersRef = this.db.usersCollection.doc(this.email).collection("users")
    users.getUsers()

}

users.del = function (email) {
    email = email.toLowerCase();
    users.parent.adminUser.sendToServer(
        "delete",
        "/users/" + email,
        function (res) {
            logs.print("users.del", res)
            if (res.status) {
                users.parent.$toastr("success", users.parent.lang.delete_success);
            } else {
                users.parent.$toastr("error", users.parent.lang[res.error_msg]);

            }
            users.getUsers();
            users.parent.pageLoading = false;

        },
        function () {
            users.parent.pageLoading = false;
        }
    );
}
users.update = function (email, name, accountName) {
    email = email.toLowerCase();
    if (name == "") name = accountName;
    users.parent.adminUser.sendToServerData(
        "put",
        "/users/" + email,
        {
            name: name,
            accountName: accountName
        },
        function (res) {

        },
        function () { }
    );
}
users.add = function (email, name, pass, accountName) {
    email = email.toLowerCase();
    users.parent.adminUser.sendToServerData(
        "put",
        "/users", {
        email: email,
        password: pass,
        name: name,
        accountName: accountName
    },
        function (res) {
            logs.print("users.add", res)
            if (res.status) {
                users.parent.$toastr("success", users.parent.lang.added_success_user);
                users.parent.allusers = []
                users.parent.refreshingUsers = true;
                users.updateUsers(res)
            } else {
                users.parent.$toastr("error", users.parent.lang[res.error_msg] || res.error_msg);
                // console.error("coupons.add", res.error_msg)
            }


        },
        function () { }
    );
}
users.getAllPlayers = function () {
    users.parent.players = {}
    this.parent.adminUser.getPlayersSummary(users.updatePlayers)
}
users.updatePlayers = function (res) {
    logs.print("updatePlayers", res.data)
    var players = {}
    if (res.status) {
        for (var i in res.data) {
            if (!res.data[i].account) {
                continue
            }
            if (!players[res.data[i].account]) {
                players[res.data[i].account] = 0
            }
            players[res.data[i].account]++
        }
        for (var i in users.parent.allusers) {
            if (users.parent.allusers[i] != null) {


                var players = res.data.Users[users.parent.allusers[i].Email]
                var item = users.parent.allusers[i]
                if (!players) {
                    item.players = 0;
                    item.onlinePlayers = 0;
                    item.offlinePlayers = 0;
                } else {
                    item.players = players.count;
                    item.onlinePlayers = players.online;
                    item.offlinePlayers = players.offline;
                }
                users.parent.allusers.splice(i, 1, item)
            }
        }
    } else {
        console.error(res.error_msg);
        //Vue.prototype.$toastr("error", res.error_msg);
    }
}
users.updateUsers = function (res) {
    users.parent.pageLoading = false;
    if (res.status) {
        if (res.status) {
            res.data.forEach(user => {
                if (user)
                    user = users.parent.adminUser.fixUser(user)
            });
        }
        users.parent.allusers = res.data;
    } else {
        console.error(res.error_msg);
        //Vue.prototype.$toastr("error", res.error_msg);
    }
    users.getAllPlayers()

}

users.getUsers = function () {
    users.parent.allusers = []
    this.parent.refreshingUsers = true;
    this.parent.pageLoading = true
    this.parent.adminUser.getAllUsers(this.updateUsers);
}




export {
    users
}